<template>
    <div
        class="fraction-switch"
        @click.prevent="$emit('change', {
            val: !fraction.enabled,
            fractionId: fraction.id
        })"
    >
        <a-switch
            :id="`fraction-${fraction.id}`"
            :checked="fraction.enabled"
        />
        <fraction-label
            :show-details="showDetails"
            :show-details-tooltip="showDetailsTooltip"
            :disabled="!fraction.enabled"
            :fraction="fraction"
            :active-color="activeColor"
        />
    </div>
</template>

<script>
export default {
    props: {
        fraction: {
            type: Object,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        showDetails: {
            type: Boolean,
            default: false
        },
        showDetailsTooltip: {
            type: Boolean,
            default: false
        },
        activeColor: {
            type: String,
            default: 'var(--color-dark)'
        }
    },

    emits: ['change']
}
</script>

<style lang="scss">
.fraction-switch {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}
</style>